import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback } from 'react';
import { Button, SnackBar } from '@carnica/ui-kit';
import { IconRightArrowFilled } from '@carnica/graphics';
import { cnBem } from '@carnica/utils';
import { useFlag, useIsDesktopDimension } from '@carnica/utils/hooks';
import { HeaderThemeView } from "../../store";
import { useGetHeaderHeight } from "../../hooks/useGetHeaderHeight";
import { EHeaderTheme } from "../../store/slices/layout";
import styles from "./styles.pcss";
import { copyToClipboard, shareData } from "./utils";
var cnShareButton = cnBem('share-button', styles);
var DEFAULT_NOTIFICATION_TEXT = 'пошарь друзьям в чатах — <br/>ссылка скопирована';
var getter = function getter(val) {
  return val;
};
export var ShareButton = function ShareButton(_ref) {
  var className = _ref.className,
    shareLink = _ref.shareLink,
    headerTheme = _ref.headerTheme;
  var isDesktop = useIsDesktopDimension();
  var _useFlag = useFlag(),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    showNotification = _useFlag2[0],
    setShowNotification = _useFlag2[1];
  var headerHeight = useGetHeaderHeight();
  var share = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _document, _document$querySelect;
    var url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = shareLink || window.location.href;
          if (!isDesktop) {
            _context.next = 5;
            break;
          }
          _context.next = 4;
          return copyToClipboard(url).then(setShowNotification.on);
        case 4:
          return _context.abrupt("return");
        case 5:
          _context.next = 7;
          return shareData({
            title: window.document.title,
            text: ((_document = document) === null || _document === void 0 ? void 0 : (_document$querySelect = _document.querySelector('meta[name="description"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.content) || undefined,
            url: url
          });
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [shareLink, isDesktop]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    "aria-label": "\u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0441\u044B\u043B\u043A\u043E\u0439",
    className: cnShareButton(null, [className]),
    iconLeft: IconRightArrowFilled,
    onClick: share,
    onlyIcon: true,
    size: "m",
    view: HeaderThemeView[headerTheme],
    "data-t-id": "components-ShareButton"
  }), isDesktop && /*#__PURE__*/React.createElement(SnackBar, {
    className: cnShareButton('snackbar'),
    getItemId: getter,
    getItemMode: function getItemMode() {
      return 'autoclose';
    },
    getItemTitle: getter,
    items: showNotification ? [DEFAULT_NOTIFICATION_TEXT] : [],
    onItemClose: setShowNotification.off,
    position: "topRight",
    style: _defineProperty({}, '--header-height', "".concat(headerHeight, "px")),
    theme: headerTheme === EHeaderTheme.dark ? 'dark' : 'light',
    truncate: false
  }));
};